import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AdminPanelHeader from "./AdminPanelHeader";

export default function RecordingAll(props) {
  const [patientVisits, setPatientVisits] = useState([]);
  const [doctorName, setDoctorName] = useState();
  const token = useSelector((state) => state.loginData.token);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/patient_visit`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      // if (response.data.code === 401) {
      // localStorage.clear();
      // window.location.reload();
      // } else {
      setPatientVisits(response.data.data.visits);
      setDoctorName(response.data.data.doctor_name);
      if (response.data.data.visits.length > 0) {
        setIsEmpty(false);
      } else {
        setIsEmpty(true);
      }
      // }
    };
    getData();
  }, []);

  return (
    <div>
      <AdminPanelHeader />
      <div className="overview-title" style={{ textAlign: "center" }}>
        <h3>Patient Visits for Dr. {doctorName}</h3>
      </div>
      {isEmpty ? (
        <div
          className="overview-title"
          style={{ textAlign: "center", paddingTop: "10px" }}
        >
          <h3 style={{ color: "red" }}>No recordings available </h3>
        </div>
      ) : (
        <div>
          <table className="table">
            <thead>
              <tr
                style={{
                  color: "#166e78",
                  fontSize: "22px",
                  textAlign: "center",
                }}
              >
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Time</th>

                <th scope="col">Name</th>
                <th scope="col">Location</th>
                <th scope="col">Condition</th>
                <th scope="col">Recordings</th>
              </tr>
            </thead>
            <tbody>
              {patientVisits.map((item, index) => (
                <tr style={{ textAlign: "center" }} key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.time}</td>
                  <td>
                    {item.patient_name == null ? "N/A" : item.patient_name}{" "}
                  </td>
                  <td>{item.location}</td>
                  <td>
                    {item.clinical_condition == "1"
                      ? "Seizure"
                      : item.clinical_condition == "2"
                        ? "Concussions"
                        : item.clinical_condition == "3"
                          ? "Stroke"
                          : ""}
                  </td>
                  <td>
                    {" "}
                    <Link
                      to={`/recording/${item.id}`}
                      className="btn btn-info btn-block "
                      onClick={() => {
                        {
                          localStorage.setItem("patientVisitId", item.id);
                        }
                      }}
                    >
                      View
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
